export enum ClientEditor {
	String = 0,
	Textarea = 1,
	Integer = 2,
	Boolean = 3,
	Select = 4,
	Password = 5,
	Colour = 6,
	Date = 7,
	Decimal = 8
}
